export const rolesBo: { [key: string]: string } = {
  'rt,click': 'Amministratore Rete Terza',
  'pcl,click': 'Operatore Poste Italiane',
  'admin,click': 'Amministratore Poste Italiane',
  'ceac,click': 'Visualizzatore Poste Italiane',
  'ort,click': 'Operatore Rete Terza',
  'vrt,click': 'Visualizzatore Rete Terza',
  'app,click': 'Approvatore Poste Italiane',
  'apprt,click': 'Approvatore Rete Terza',
  'opterr,click': 'Operatore Territoriale'
};
